import React           from 'react'
import SharedFlatpickr from "@shared/flatpickr"
import { useCalendar } from './useCalendar';
import { CALENDAR_VIEWS } from '@helpers/javascript/calendar_helper'

const MiniCalendar = () => {
  const { state, setState, filter } = useCalendar()

  const stackedMode = filter.view.name === CALENDAR_VIEWS.agenda && filter.stackedAgenda

  const goToDate = dateArray => {
    const [date] = dateArray
    if (stackedMode || !state.calendar) {
      // Stacked "Semaine (vertical)": no single FullCalendar instance, the
      // shared date lives in the context and drives every stacked grid.
      setState(prevState => ({ ...prevState, currentDate: new Date(date) }))
    } else {
      state.calendar.gotoDate(moment(date).format('YYYY-MM-DDTHH:mm:ss'))
    }
  }

  const disableWeekends = date => {
    return filter.showWeekends ? false : (date.getDay() === 0 || date.getDay() === 6);
  }

  return (
    <div className="flatpickr-wrapper">
      <SharedFlatpickr
        value={state.currentDate || new Date()}
        onChange={goToDate}
        options={{
          inline: true,
          altInput: true,
          altInputClass: "hidden",
          disable: [disableWeekends],
          locale: I18n.locale
        }}
      />
    </div>
  )
}

export default MiniCalendar
